import { createCommand } from 'lexical';

export const INSERT_IMAGE_COMMAND = createCommand<string>('INSERT_IMAGE');
